<template>
  <div class="smy__card-full-box">
    <Card :bordered="false" class="smy__card-full">
      <p slot="title">客户列表</p>
      <div class="search">
        <!-- 详细筛选条件 -->
        <div>
          <div
            class="search-detail"
            :class="{ 'search-detail-close': !searchVisible }"
            :style="{ overflow: !searchVisible ? 'hidden' : '' }"
          >
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入企业名称"
                v-model="searchForm.name"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入corpID"
                v-model="searchForm.corpid"
              ></Input>
            </div>
            <div class="search-detail-item">
              <DateRangePicker
                class="search-input"
                :placeholder="'请选择开通时间'"
                :value="emptyOrderTime"
                @on-change="
                  daterangeOrderChange(
                    $event,
                    'start_create_time',
                    'end_create_time',
                    'emptyOrderTime'
                  )
                "
              />
            </div>
            <div class="search-detail-item">
              <DateRangePicker
                class="search-input"
                placement="bottom-end"
                :placeholder="'请选择服务到期时间'"
                :value="emptyOpenTime"
                @on-change="
                  daterangeOrderChange(
                    $event,
                    'start_service_expire_time',
                    'end_service_expire_time',
                    'emptyOpenTime'
                  )
                "
              />
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                multiple
                class="search-input"
                placeholder="请选择套餐人数"
                element-id="package_id"
                v-model="packageId"
              >
                <Option
                  v-for="spareType in buyPeople"
                  :key="spareType.value"
                  :value="spareType.value + ''"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择专属客服"
                element-id="custom_service_id"
                v-model="searchForm.custom_service_id"
              >
                <Option
                  v-for="servicePeople in customServiceData"
                  :key="servicePeople.id"
                  :value="servicePeople.id + ''"
                >
                  {{ servicePeople.name }}
                </Option>
              </Select>
            </div>

            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择付费类型"
                v-model="searchForm.charge_type"
              >
                <Option
                  v-for="(item, index) in Payment_type_list"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <AddressSelect
                placeholder="请选择区域地址"
                :value="address_city"
                @on-change="
                  (e) => {
                    ;(searchForm.prov_id = e[0]), (searchForm.city_id = e[1])
                  }
                "
                :level="2"
              />
            </div>

            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择行业"
                v-model="searchForm.industry"
              >
                <Option
                  v-for="(item, index) in listIndustry"
                  :key="item.industry"
                  :value="item.industry"
                >
                  {{ item.industry }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <DateRangePicker
                class="search-input"
                :placeholder="'请选择提醒时间范围'"
                :value="PromptTime"
                @on-change="
                  daterangeOrderChange(
                    $event,
                    'remindTimeStart',
                    'remindTimeEnd'
                  )
                "
              />
            </div>
            <div class="search-detail-item">
              <DateRangePicker
                class="search-input"
                :placeholder="'请选择跟进时间范围'"
                :value="FollowuponTime"
                @on-change="
                  daterangeOrderChange(
                    $event,
                    'start_follow_up_time',
                    'end_follow_up_time'
                  )
                "
              />
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择跟进节点"
                v-model="searchForm.follow_up_type"
              >
                <Option
                  v-for="spareType in followUpType"
                  :key="spareType.value"
                  :value="spareType.value + ''"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                multiple
                class="search-input"
                placeholder="请选择客户标签"
                v-model="allcustomLable"
              >
                <Option
                  v-for="spareType in Labledata"
                  :key="spareType.id"
                  :value="spareType.id + ''"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <Button
                type="primary"
                class="search-button"
                @click=";(pageIndex = 0), loadList()"
              >
                查找
              </Button>
              <Button class="search-button" @click="resetSearchForm">
                重置
              </Button>
              <FilterColumn
                :column="allColumns"
                @columnsChecked="columnsChecked = $event"
              />
            </div>
          </div>
        </div>
        <div class="top">
          <div class="top-right" style="float: right; padding: 50px 17px 0">
            <Button
              type="primary"
              class="mass-distribution"
              @click="distribuSerive"
            >
              批量分配客服
            </Button>
            <Button
              type="primary"
              class="mass-distribution"
              @click="allLableclick"
            >
              批量打标
            </Button>
          </div>
        </div>
      </div>
      <!-- 工单列表 -->
      <div class="table table-sticky">
        <Table
          stripe
          highlight-row
          :height="count < 4 ? '' : 480"
          ref="table"
          :loading="listLoading"
          :columns="columns"
          :data="list"
          @on-select-all="selectAll"
          @on-selection-change="handleRowChange"
        ></Table>
      </div>
      <!-- 分页控件 -->
      <Page
        show-total
        show-sizer
        class="page"
        placement="top"
        :current="pageIndex + 1"
        :total="count"
        :page-size-opts="pageSizeOpts"
        @on-change="pageIndexChange"
        @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
    <!--编辑联系人-->
    <EditContact
      :agentId="agentId"
      :editModal="editModal"
      :editTitle="editTitle"
      :editRow="editRow"
      @callback="loadList()"
      @backeditModal="editModal = false"
    />
    <!--模板数更改-->
    <TemplateNumberChange
      :agentId="agentId"
      :templateModal="templateModal"
      :templateTitle="editTitle"
      :templateRow="editRow"
      @callback="loadList()"
      @backeditModal="templateModal = false"
    />
    <!--分配客服-->
    <DistriCustomerService
      :agentId="agentId"
      :distriServeModal="distriServeModal"
      :distriServeTitle="editTitle"
      :distriServeRow="editRow"
      :epIds="epIds"
      @callback="loadList()"
      @backeditModal="distriServeModal = false"
    />
    <!--短信充值-->
    <ShortMessageRecharge
      :agentId="agentId"
      :sMessageModal="sMessageModal"
      :sMessageTitle="editTitle"
      :sMessageRow="editRow"
      @callback="loadList()"
      @backeditModal="sMessageModal = false"
    />
    <!--新增跟进记录-->
    <NewFollowUpRecords
      :agentId="agentId"
      :followUpRecModal="followUpRecModal"
      :followUpRecTitle="editTitle"
      :followUpRecRow="editRow"
      @callback="loadList()"
      @backeditModal="followUpRecModal = false"
    />

    <!-- 企业跟进提醒 -->
    <FollowupremindModals
      :agentId="agentId"
      :followUpRecModal="followupremindModal"
      :followUpRecTitle="folloeditTitle"
      :followUpRecRow="folloeditRow"
      @callback="loadList()"
      @backeditModal="followupremindModal = false"
    />

    <!-- 打标 -->
    <!-- <AllLable
      :agentId="agentId"
      :distriServeModal="allLableModal"
      :distriServeTitle="editTitle"
      :distriServeRow="editRow"
      :epIds="epIds"
      @callback="loadList()"
      @backeditModal="allLableModal = false; epIds = ''"
    /> -->
    <AllLable1
      attached
      :distriServeTitle="editTitle"
      v-model="allLableModal"
      :sparepart="editRow"
      @on-success="LabelItem"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'

import DateRangePicker from '@/components/DateRangePicker'
import EditContact from './EditContact'
import TemplateNumberChange from './TemplateNumberChange'
import DistriCustomerService from './DistriCustomerService'
import ShortMessageRecharge from './ShortMessageRecharge'
import NewFollowUpRecords from './NewFollowUpRecords'
import FollowupremindModals from './FollowupremindModals'
// import AllLable from './AllLable'
import AllLable1 from './AllLable1'
import { followUpType } from '@/assets/globalData'
import AddressSelect from '@/components/AddressCB'

export default {
  name: 'followCustomList',
  components: {
    DateRangePicker,
    EditContact,
    TemplateNumberChange,
    DistriCustomerService,
    ShortMessageRecharge,
    NewFollowUpRecords,
    FollowupremindModals,
    AddressSelect,
    AllLable1,
  },
  data() {
    return {
      columnsChecked: [],
      emptyOrderTime: ['', ''],
      emptyOpenTime: ['', ''],
      buyPeople: '',
      Labledata: [],
      customServiceData: '',
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      epIds: '',
      searchForm: {
        corpid: '',
        orederTimeStart: '',
        orderTimeEnd: '',
        openTimeStart: '',
        package_ids: '',
        openTimeEnd: '',
        custom_service_id: '',
        charge_type: '',
        follow_up_type: '',
        PromptTime: [],
        FollowuponTime: [],
        industry: '',
        labelIds: '',
      },
      agentId: 1,
      editTitle: '编辑联系人',
      editRow: {},
      editModal: false,
      templateModal: false,
      distriServeModal: false,
      sMessageModal: false,
      followUpRecModal: false,
      followupremindModal: false,
      folloeditTitle: '',
      folloeditRow: {},
      followUpType,
      Payment_type_list: [
        { id: 0, name: '免费用户' },
        { id: 1, name: '付费用户' },
        { id: 2, name: '试用用户' },
        { id: 3, name: '免费规格' },
      ],
      listIndustry: [],
      packageId: [],
      allcustomLable: [],
      allLableModal: false,
    }
  },
  computed: {
    ...mapState('table', ['columnsCheckedAll', 'pageSizeOpts']),
    ...mapState('global', ['userCategory']),
    ...mapState('user', ['user']),
    // 表格列 根据选中的列动态生成
    allColumns() {
      const allColumns = [
        {
          title: '操作',
          width: 300,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let smartPhone = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    let url = '/enterprise/mgr/call'
                    let data = {
                      epId: row.id,
                    }
                    this.$http.post(url, data).then((res) => {
                      if (res.success) {
                        let msg = '拨打成功'
                        this.$Message.success(msg)
                        this.loadList()
                      } else {
                        this.$Message.error(res.message)
                      }
                    })
                  },
                },
                style: {
                  marginLeft: '10px',
                  marginTop: '5px',
                  marginBottom: '5px',
                },
              },
              ['智能电话']
            )
            let editBtn = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.editTitle = '编辑联系人'
                    this.agentId = row.id
                    this.editRow = row
                    this.editModal = true
                  },
                },
                style: {
                  marginLeft: '10px',
                  marginTop: '5px',
                  marginBottom: '5px',
                },
              },
              ['编辑联系人']
            )
            let templateNumber = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.editTitle = '模板数量更改'
                    this.agentId = row.id
                    this.editRow = row
                    this.templateModal = true
                  },
                },
                style: {
                  marginLeft: '10px',
                  marginTop: '5px',
                  marginBottom: '5px',
                },
              },
              ['模板数更改']
            )
            let distriServeNumber = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.editTitle = '分配客服'
                    this.agentId = row.id
                    this.editRow = row
                    this.distriServeModal = true
                  },
                },
                style: {
                  marginLeft: '10px',
                  marginTop: '5px',
                  marginBottom: '5px',
                },
              },
              ['分配客服']
            )
            let sMessRecharge = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.editTitle = '短信充值'
                    this.agentId = row.id
                    this.editRow = row
                    this.sMessageModal = true
                  },
                },
                style: {
                  marginLeft: '10px',
                  marginTop: '5px',
                  marginBottom: '5px',
                },
              },
              ['短信充值']
            )
            let newFollowUpRec = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.editTitle = '新增跟进记录'
                    this.agentId = row.id
                    this.editRow = row
                    this.followUpRecModal = true
                  },
                },
                style: {
                  marginLeft: '10px',
                  marginTop: '5px',
                  marginBottom: '5px',
                },
              },
              ['新增跟进记录']
            )
            let followupremind = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.folloeditTitle = '企业跟进提醒'
                    this.agentId = row.id
                    this.folloeditRow = row
                    this.followupremindModal = true
                  },
                },
                style: {
                  marginLeft: '10px',
                  marginTop: '5px',
                  marginBottom: '5px',
                },
              },
              ['企业跟进提醒']
            )
            let check = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'CusFollowDetail',
                      params: { orderId: row.id },
                    })
                  },
                },
                style: {
                  marginLeft: '10px',
                },
              },
              ['查看']
            )
            let allLable = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.agentId = row.id
                    this.editRow = row
                    this.editTitle = '编辑标签'
                    this.allLableModal = true
                    this.epIds = ''
                  },
                },
                style: {
                  marginLeft: '10px',
                  marginTop: '5px',
                  marginBottom: '5px',
                },
              },
              ['编辑标签']
            )
            if (row.contact_call > 0) {
              return h('span', [
                smartPhone,
                editBtn,
                newFollowUpRec,
                followupremind,
                check,
                allLable,
              ])
            } else if (this.user.isMain === 1 && this.user.sysrole === 1) {
              return h('span', [
                smartPhone,
                editBtn,
                templateNumber,
                distriServeNumber,
                sMessRecharge,
                newFollowUpRec,
                followupremind,
                check,
                allLable,
              ])
            } else {
              return h('span', [
                editBtn,
                newFollowUpRec,
                followupremind,
                check,
                allLable,
              ])
            }
          },
        },
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: 'id',
          key: 'id',
          width: 80,
        },
        {
          title: '企业名称',
          key: 'name',
          width: 180,
        },
        {
          title: 'corpid',
          key: 'corpid',
          width: 180,
          ellipsis: true,
        },
        {
          title: '行业',
          key: 'industry',
          width: 160,
        },
        {
          title: '区域',
          key: 'area',
          width: 160,
        },
        {
          title: '跟进时间',
          key: 'follow_up_time',
          width: 180,
        },
        {
          title: '跟进节点',
          key: 'follow_up_type',
          width: 160,
          render: (h, { row }) => {
            if (!row.follow_up_type) return ['']
            return [
              this.followUpType.filter(
                (item) => item.value === row.follow_up_type
              )[0].name,
            ]
          },
        },
        {
          title: '跟进记录',
          key: 'follow_up_content',
          width: 160,
        },
        {
          title: '联系人',
          key: 'link_person',
          width: 120,
        },
        {
          title: '联系电话',
          key: 'link_msisdn',
          width: 160,
        },
        {
          title: '主管理员名称',
          key: 'main_user_name',
          width: 180,
        },
        {
          title: '开通时间',
          key: 'create_time',
          width: 180,
        },
        {
          title: '服务到期时间',
          key: 'service_expire_time',
          width: 180,
        },
        {
          title: '服务人员数量',
          key: 'user_num',
          width: 180,
        },
        {
          title: '套餐名称',
          key: 'package_name',
          width: 180,
        },
        {
          title: '专属客服名称',
          key: 'custom_service_name',
          width: 180,
        },
        {
          title: '短信数量',
          key: 'sms_limit_size',
          width: 120,
        },
        {
          title: '使用版本',
          key: 'is_charge_user',
          width: 120,
          render: (h, { row }) => {
            // let Type = ''
            // if (row.is_charge_user === 1) {
            //   Type = 'VIP版'
            // } else if (row.is_charge_user === 2) {
            //   Type = '试用版'
            // } else {
            //   Type = '免费版'
            // }
            // return h('span', [Type])
            let typename = ''
            if (
              (row.fk_t_charge_package_id === null ||
                row.fk_t_charge_package_id === -1) &&
              row.is_charge_user === 0
            ) {
              typename = this.userCategory[0].name
            } else if (
              row.fk_t_charge_package_id !== null &&
              row.is_charge_user !== 0 &&
              row.is_charge_user !== 3
            ) {
              typename = this.userCategory[1].name
            } else if (
              (row.fk_t_charge_package_id === null ||
                row.fk_t_charge_package_id === -1) &&
              row.is_charge_user !== 0 &&
              row.is_charge_user !== 3
            ) {
              typename = this.userCategory[2].name
            } else if (row.is_charge_user === 3) {
              typename = this.userCategory[3].name
            }
            return h('span', [typename])
          },
        },
        {
          title: '客户标签',
          key: 'label',
          width: 120,
        },
        {
          key: ' ',
          title: ' ',
        },
      ]
      return allColumns
    },
    columns() {
      const allColumns = this.allColumns
      let arr = allColumns.filter((col) => {
        if (!col.key || !col.key.trim()) {
          return true
        } else {
          if (this.columnsChecked.length) {
            return this.columnsChecked.includes(col.key)
          } else {
            return true
          }
        }
      })
      if (this.columnsChecked.length) {
        let indexMap = this.columnsChecked.reduce((p, c, i) => {
          p[c] = i
          return p
        }, {})
        let left = arr.filter((col) => this.columnsChecked.includes(col.key))
        let right = arr.filter((col) => !this.columnsChecked.includes(col.key))
        arr = left
          .sort((p, c) => indexMap[p.key] - indexMap[c.key])
          .concat(right)
      }
      return arr
    },
    PromptTime() {
      return [this.searchForm.remindTimeStart, this.searchForm.remindTimeEnd]
    },
    FollowuponTime() {
      return [
        this.searchForm.start_follow_up_time,
        this.searchForm.end_follow_up_time,
      ]
    },
    address_city() {
      return [this.searchForm.prov_id, this.searchForm.city_id]
    },
  },
  watch: {
    state(val) {},
  },
  methods: {
    // 加载列表数据
    loadList() {
      this.listLoading = true
      this.searchForm.package_ids = this.packageId.join(',')
      this.searchForm.labelIds = this.allcustomLable.join(',')
      this.$http
        .all([
          this.$http.get('/enterprise/mgr/list', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              ...this.searchForm,
            },
          }),

          this.$http.get('/enterprise/mgr/count', {
            params: this.searchForm,
          }),
        ])
        .then(
          this.$http.spread((res1, res2) => {
            this.list = res1.data
            this.count = res2.data
            this.listLoading = false
          })
        )
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeOrderChange(daterange, start, end, emptyTime) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0]
          .replace('/', '-')
          .replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      //    this.emptyOrderTime = [this.searchForm[start], this.searchForm[end]]
      this[emptyTime] = [this.searchForm[start], this.searchForm[end]]
    },
    // 重置搜索框
    resetSearchForm() {
      this.emptyOrderTime = ['', '']
      this.emptyOpenTime = ['', '']
      this.searchForm = {
        name: '',
        corpid: '',
        start_create_time: '',
        end_create_time: '',
        start_service_expire_time: '',
        end_service_expire_time: '',
        custom_service_id: '',
        charge_type: '',
        follow_up_type: '',
        PromptTime: [],
        FollowuponTime: [],
        industry: '',
        labelIds: '',
      }
      this.packageId = []
      this.allcustomLable = []
      this.loadList()
    },
    editReport() {
      this.editReportCurstom = true
    },
    selectAll(selection) {
      this.epIds = selection.map((item) => item.id).join(',')
    },
    handleRowChange(selection) {
      if (selection) {
        this.epIds = selection.map((item) => item.id).join(',')
        //      console.log(this.epIds)
      }
    },
    distribuSerive() {
      this.editRow = null
      this.editTitle = '分配客服'
      this.distriServeModal = true
    },
    allLableclick() {
      if (this.epIds === '') {
        return this.$Message.error('请选择行数')
      }
      this.editTitle = '添加标签'
      this.allLableModal = true
    },
    // 回调
    LabelItem(row) {
      let url = ''
      let data = {}
      if (this.epIds) {
        // 新增
        console.log(this.epIds)
        url = '/label/related/obj'
        data = {
          type: '1',
          labelIds: row.map((v) => v.id),
          objectIds: this.epIds.split(','),
        }
      } else {
        // 编辑
        url = '/label/edit/obj'
        data = {
          type: '1',
          labelIds: row.map((v) => v.id),
          objectId: this.agentId,
        }
      }
      this.$http.post(url, data).then((res) => {
        if (res.success) {
          let msg = '修改成功'
          this.$Message.success(msg)
          this.distriServeListModal = false
          this.loadList()
        } else {
          this.$Message.error(res.message)
        }
        this.agentId = -1
      })
    },
  },
  activated() {
    this.loadList()
  },
  created() {
    this.$http.get('/user/listBySysrole?sysrole=8').then((res) => {
      this.customServiceData = res.data
    })
    this.$http.get('/dropdown/chargePackage').then((res) => {
      this.buyPeople = res.data
    })
    this.$http.get('/label/list').then((res) => {
      this.Labledata = res.data
    })
    this.$http.get('/enterprise/analyze/listIndustry').then((res) => {
      this.listIndustry = res.data
    })
    this.loadList()
  },
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    height: 80px;
    transition: 0.5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
      }
    }

    .search-detail-item:nth-child(2n + 1),
    .search-detail-item:nth-child(4n + 2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/index.vue